import React from 'react';
import PropTypes from 'prop-types';
import './SemblePhysioBookingStatus.sass';

const SemblePhysioBookingStatus = ({ status }) => {
  // Semble's status vocabulary is unconfirmed - this will beed updating
  const sembleAppointmentStatusToCleanStatus = {
    booked: { cleanStatus: 'Booked', cssModifier: 'green' },
    completed: { cleanStatus: 'Attended', cssModifier: 'light-green' },
    cancelled: { cleanStatus: 'Cancelled', cssModifier: 'red' },
    noshow: { cleanStatus: 'No show', cssModifier: 'red' },
  };

  const { cleanStatus, cssModifier } = sembleAppointmentStatusToCleanStatus[status] || {
    cleanStatus: status,
    cssModifier: 'green',
  };
  const className = `physio-appointment-status physio-appointment-status__${cssModifier} bold`;
  return (
    <div className={className}>
      <span>{cleanStatus}</span>
    </div>
  );
};

SemblePhysioBookingStatus.propTypes = {
  status: PropTypes.string.isRequired,
};

export default SemblePhysioBookingStatus;
